import { StyleSheet } from '@react-pdf/renderer';

export const infoBoxes = StyleSheet.create({
  container: {
    padding: 8,
    backgroundColor: '#F2F2F2',
    border: '1px solid #d3d3d8',
    borderRadius: 2,
  },
  verificationContainer: { height: '160px' },
  fileDetailsContainer: { height: '160px' },
  title: { fontSize: 12, marginBottom: 8, fontWeight: 'semibold', color: '#2E2E2E' },
  section: { padding: 8, marginBottom: 1, backgroundColor: 'white' },
  label: { fontSize: 10, fontWeight: 'semibold', color: '#2E2E2E' },
  value: { fontSize: 10 },
  link: { color: '#4F8EF7', textDecoration: 'underline' },
});
